export function createDragPositionPreview(command) {
  const preview = new Map();
  if (!Array.isArray(command?.positions)) return preview;

  command.positions.forEach((entry) => {
    if (!entry?.id || !Number.isFinite(entry.position?.x) || !Number.isFinite(entry.position?.y)) {
      return;
    }
    preview.set(entry.id, { ...entry.position });
  });

  return preview;
}

export function getRenderedNodePosition(node, preview) {
  const previewPosition = preview instanceof Map ? preview.get(node?.id) : null;
  if (Number.isFinite(previewPosition?.x) && Number.isFinite(previewPosition?.y)) {
    return previewPosition;
  }
  if (Number.isFinite(node?.position?.x) && Number.isFinite(node?.position?.y)) {
    return node.position;
  }
  return { x: 0, y: 0 };
}

export function dragPreviewMatchesNodes(preview, nodes) {
  if (!(preview instanceof Map) || preview.size === 0) return true;
  const nodesById = new Map((Array.isArray(nodes) ? nodes : []).map((node) => [node.id, node]));

  return [...preview.entries()].every(([nodeId, position]) => {
    const stored = nodesById.get(nodeId)?.position;
    return stored?.x === position.x && stored?.y === position.y;
  });
}
